import {
  getApprovalMastersKey,
  useCreateApprovalMaster,
} from 'api-hooks/approval-master';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import { queryClient } from 'common/repositories/query-client';
import notification from 'components/common/notification';
import { SeparatorVertical } from 'components/styles';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import useNavigation from 'hooks/use-navigation';
import { NavigationProps } from 'types';

import ApprovalMasterForm from './components/form';

export type ApprovalMasterCreateParams = null;

export default function ApprovalMasterCreate(
  props: NavigationProps<NavigationRoutes.ApprovalMastersCreate>,
) {
  const { navigate } = useNavigation();

  const { mutateAsync, error } = useCreateApprovalMaster();
  const permission = useGetCrudPermission('approvals');
  return (
    <>
      {!!error && !!error.message && (
        <>
          <Notification
            overrides={{
              Body: { style: { width: 'auto', wordBreak: 'break-all' } },
            }}
            kind={KIND.negative}
            closeable
          >
            {() => error.message}
          </Notification>
          <SeparatorVertical $margin={8} />
        </>
      )}
      <ApprovalMasterForm
        {...props}
        onSubmit={async (input, form) => {
          const result = await mutateAsync(input);

          queryClient.refetchQueries([getApprovalMastersKey()[0]]);

          if (permission.view) {
            navigate(NavigationRoutes.ApprovalMastersView, {
              id: result.data?.id,
            });
          }
          notification.success({ message: result?.message });

          return result.data;
        }}
      />
    </>
  );
}
